import { FC, useMemo } from 'react';
import { useTable, Table } from 'portal-commons';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';

import { eventController, EventHistory } from '@/apis/core';
import RcsSectionBlock from './RcsSectionBlock';
import EventsListingRow from '../EventsListingRow';
import { MAX_EVENT_RECORDS } from '../../../Events/constants';

const headRows = [
  { label: 'EVENT TYPE', id: 'eventType', sortable: false },
  { label: 'CATEGORY', id: 'categoryType', sortable: false },
  { label: 'CAMPAIGN ID', id: 'campaignUid', sortable: false },
  { label: 'BRAND ID', id: 'brandUid', sortable: false },
  { label: 'DATE & TIME', id: 'createDate', sortable: true },
  { label: 'DESCRIPTION', id: 'description', sortable: false },
];

const EventsSection: FC<{ campaignUid: string }> = ({ campaignUid }) => {
  const table = useTable<EventHistory>(
    async (tableFilter) => {
      const response = await eventController.getEventHistory({
        ...tableFilter,
        campaignUid,
      });
      return {
        data: response?.records || [],
        rowsPerPage: response?.recordsPerPage || 10,
        total: response?.totalRecords || 0,
        page: response?.page || 1,
      };
    },
    {
      deps: [campaignUid],
      inMemory: true,
      cappingTotal: MAX_EVENT_RECORDS,
      defaultFilter: {
        ascendingOrder: false,
        sortField: 'createDate',
      },
    }
  );

  const normalizedTableData = useMemo(() => {
    return table.tableData.map((record) => (
      <EventsListingRow key={record.id} event={record} withoutUser />
    ));
  }, [table.tableData]);

  return (
    <RcsSectionBlock
      icon={faCalendarRange}
      title="Events"
      showDivider={true}
      data-testid="campaignEvents"
    >
      <Table
        disableHover
        headRows={headRows}
        emptyState="no events to view"
        emptyBlockHeight="180px"
        loading={table.loading}
        tableData={normalizedTableData}
        filter={table.filter}
        handleChangePage={table.handleChangePage}
        createSortHandler={table.handleSorting}
        pagination={table.pagination}
      />
    </RcsSectionBlock>
  );
};

export default EventsSection;
